<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar dense class="toolbar" flat>
                <v-toolbar-title>Employee Salary Certificate</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data() {
            return {
                snackbar_msg: "",
                color: "",
                snackbar: false,
                search: "",
                emp_sal_application_list:[],
                sal_reason_list:[],
                sal_month_list:[],
            };
        },
        mounted() {
            this.onload()
        },
        methods: {
             showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            formatDate(date) {
                if (!date) return null;
                const [year, month, day] = date.split("-");
                return `${day}/${month}/${year}`;
            },
            parseDate(date) {
                if (!date) return null;
                const [month, day, year] = date.split("/");
                return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
            },
            onload(){
                 axios
                .post("/Payroll/applySalaryCertificate")
                .then((res) => {
                    if (res.data.flag == "YES") {
                       this.sal_month_list = res.data.sal_month_list
                       this.sal_reason_list = res.data.sal_reason_list
                       this.emp_sal_application_list = res.data.emp_sal_application_list
                    } 
                })
                .catch((error) => {
                    window.console.log(error);
                    this.showSnackbar("#b71c1c", "Something Went Wrong");
                });
            }
        }
    };
</script>
<style scoped></style>
